import type { ReactNode } from 'react';
import { Box, Collapse, IconButton, Text } from '@ksyos/design-system';

interface IMedicationsCollapsibleProps {
    children: ReactNode;
    className?: string;
    extraHeaderElements?: ReactNode;
    header?: string;
    isOpen: boolean;
    onToggle: () => void;
    subHeader?: string;
}

export function MedicationsCollapsible(props: IMedicationsCollapsibleProps) {
    return (
        <Box className={props.className}>
            <Box
                alignItems="center"
                display="flex"
                flexWrap="wrap"
                gap={3}
                onClick={() => props.onToggle()}
                py={4}
                sx={{ '&:hover': { backgroundColor: 'neutral50' }, cursor: 'pointer' }}
                width="100%"
            >
                <Box
                    alignItems="center"
                    display="flex"
                >
                    <IconButton
                        icon={props.isOpen ? 'caret-up' : 'caret-down'}
                        iconColor="subtle"
                        onClick={() => props.onToggle()}
                        size="small"
                        sx={{ mr: 3 }}
                    />
                    <Text
                        color="subtle"
                        fontWeight="medium"
                        size="sm"
                    >
                        {props.header}{' '}
                        {props.subHeader && (
                            <Text
                                as="span"
                                color="subtle"
                                fontWeight="normal"
                                size="sm"
                            >
                                {props.subHeader}
                            </Text>
                        )}
                    </Text>
                </Box>
                {props.isOpen && props.extraHeaderElements}
            </Box>
            <Collapse isOpen={props.isOpen}>{props.children}</Collapse>
        </Box>
    );
}
